var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-search-box",
        { on: { enter: _vm.getList } },
        [
          _c("template", { slot: "search" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-plant", {
                  attrs: { type: "search", name: "plantCd" },
                  model: {
                    value: _vm.searchParam.plantCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "plantCd", $$v)
                    },
                    expression: "searchParam.plantCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-datepicker", {
                  attrs: {
                    range: true,
                    defaultStart: "-6M",
                    defaultEnd: "6M",
                    label: "제안기간",
                    name: "period",
                  },
                  model: {
                    value: _vm.searchParam.period,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "period", $$v)
                    },
                    expression: "searchParam.period",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-dept", {
                  attrs: {
                    isFirstValue: false,
                    type: "search",
                    name: "execDeptCd",
                    label: "개선실행부서",
                  },
                  model: {
                    value: _vm.searchParam.execDeptCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "execDeptCd", $$v)
                    },
                    expression: "searchParam.execDeptCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-select", {
                  attrs: {
                    type: "search",
                    stepperGrpCd: "SAI_SUGGESTION_STATUS_STEP_CD",
                    itemText: "stepperMstNm",
                    itemValue: "stepperMstCd",
                    name: "suggestionStepCd",
                    label: "진행상태",
                  },
                  model: {
                    value: _vm.searchParam.suggestionStepCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "suggestionStepCd", $$v)
                    },
                    expression: "searchParam.suggestionStepCd",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c(
        "c-table",
        {
          ref: "table",
          attrs: {
            title: "제안 목록",
            columns: _vm.grid.columns,
            gridHeight: _vm.grid.height,
            data: _vm.grid.data,
            rowKey: "saiSobBoardOpinionId",
            columnSetting: false,
            expandAll: true,
          },
          on: { linkClick: _vm.linkClick },
        },
        [
          _c(
            "template",
            { slot: "table-button" },
            [
              _c(
                "q-btn-group",
                { attrs: { outline: "" } },
                [
                  _vm.editable
                    ? _c("c-btn", {
                        attrs: { label: "LBLREG", icon: "add" },
                        on: { btnClicked: _vm.bookPopup },
                      })
                    : _vm._e(),
                  _c("c-btn", {
                    attrs: { label: "LBLSEARCH", icon: "search" },
                    on: { btnClicked: _vm.getList },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }